import React from "react";

export function CardSkeleton() {
  return (
    <div className="border border-ink-200 bg-bone p-8" data-testid="skeleton-card">
      <div className="skeleton h-10 w-10 mb-6 rounded-sm" />
      <div className="skeleton h-6 w-3/4 mb-3" />
      <div className="skeleton h-4 w-full mb-2" />
      <div className="skeleton h-4 w-5/6" />
    </div>
  );
}

export function LineSkeleton({ width = "w-full" }) {
  return <div className={`skeleton h-4 ${width} my-2`} />;
}

export function FrameworkSkeleton() {
  return (
    <div className="space-y-4" data-testid="skeleton-framework">
      <div className="skeleton h-10 w-1/2" />
      <div className="skeleton h-4 w-full" />
      <div className="skeleton h-4 w-11/12" />
      <div className="skeleton h-6 w-1/3 mt-8" />
      <div className="skeleton h-4 w-full" />
      <div className="skeleton h-4 w-5/6" />
      <div className="skeleton h-4 w-4/5" />
      <div className="skeleton h-6 w-1/4 mt-8" />
      <div className="skeleton h-4 w-full" />
      <div className="skeleton h-4 w-3/4" />
    </div>
  );
}
